import React, { PropsWithChildren, useState } from 'react';

import styled from 'styled-components';

const StyleClickableArea = styled.div`
  position: absolute;
  right: 0;
  top: ${props => props.top || '0'};

  width: 60px;
  height: 80px;
  cursor: pointer;
  i {
    position: absolute;
    right: 19px;
    top: 37px;

    transform: ${props => (props.isCollapsed ? 'rotate(0)' : 'rotate(-90deg)')};
    transition: transform 0.5s;
  }
`;

const StyledCollapsed = styled.div`
  overflow: ${props => props.isCollapsed ? 'hidden' : 'auto'};
  max-height: ${props => (props.isCollapsed ? '0' : '1000px')};
  transition: max-height 0.5s;
`;

type Props = {
  isExpanded?: boolean;
  top?: string;
};

const CollapsableItem = ({
  children,
  isExpanded,
  top,
}: PropsWithChildren<Props>) => {
  const [isCollapsed, setIsCollapsed] = useState(!isExpanded);
  return (
    <>
      <StyleClickableArea
        isCollapsed={isCollapsed}
        onClick={() => setIsCollapsed(!isCollapsed)}
        data-collapsed={isCollapsed}
        top={top}
      >
        <i className='fas fa-caret-left fa-lg' />
      </StyleClickableArea>
      <StyledCollapsed isCollapsed={isCollapsed}>{children}</StyledCollapsed>
    </>
  );
};

export default CollapsableItem;
